export function parse(str) {
  if (!str) {
    return {};
  }
  return str.split('&').reduce((acc, param) => {
    const [key, value] = param.split('=');
    acc[key] = value;
    return acc;
  }, {});
}
export function stringify(obj) {
  const query = Object.keys(obj).map(arg => `${arg}=${obj[arg]}`).join('&');
  return query ? `?${query}` : query;
}
//# sourceMappingURL=query-string.js.map